/* eslint-disable @typescript-eslint/member-ordering */
import { Component, Input, OnChanges, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { uniqueId, merge, isEmpty } from 'lodash';
import { TooltipService } from '@nrwl/common-lib';
import { TimeoutWrapperService } from '../../../providers/timeout.wrapper/timeout.wrapper.service';
@Component({
  selector: 'nrwl-spark-line-chart',
  templateUrl: './spark-line-chart.component.html',
  styleUrls: ['./spark-line-chart.component.scss']
})
export class SparkLineChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() chartOptions: Highcharts.Options;
  @Input() dataSource: any;
  @Input() units: any = 'ms';
  @Input() fullUpdate? = false;

  chart: any;
  chartId: string;
  plotBands = [];
  constructor(
    private readonly timeout: TimeoutWrapperService,
    private readonly tooltipService: TooltipService
  ) {
    this.chartId = uniqueId('spark-line-');
  }

  ngOnInit(): void {
    this.drawChart();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataSource && changes.dataSource.currentValue) {
      this._updateChart();
    }
    if (changes.chartOptions && changes.chartOptions.currentValue) {
      this.drawChart();
    }
  }

  ngOnDestroy() {
    if (this.timeout) {
      // we can do that since timeout service is privately provided to this widget
      this.timeout.onDestroy();
    }
    if (!isEmpty(this.chart)) {
      this.chart.destroy();
      this.chart = null;
    }
  }

  private _updateChart(): void {
    if (this.chart?.series && this.dataSource?.length) {
      if (this.fullUpdate) {
        this.chart.update(this.getChartOptions());
      } else {
        //eslint-disable-next-line
        const chartOpt: any = this.getChartOptions();
        if (chartOpt && chartOpt.series && chartOpt.series.length > 0) {
          for (let i = 0, len = chartOpt.series.length; i < len; ++i) {
            if (this.chart.series[i]) {
              this.chart.series[i].setData(chartOpt.series[i].data, false, true);
              this.chart.series[i].update({ zones: chartOpt.series[i].zones });
            } else {
              this.chart.addSeries(chartOpt.series[i], false);
            }
          }
          this.chart.redraw();
        }
      }
    }
  }

  drawChart(): void {
    if (!isEmpty(this.chart)) {
      this.chart.destroy();
    }

    this.timeout.add(() => {
      // if (this.dataSource.length) {
      this.chart = new Highcharts.Chart(this.chartId, this.getChartOptions());
      // for (let i = 0; i < this.dataSource?.length; i++) {
      //   this.chart.addSeries(this.dataSource[i], true);
      // }
      // }
    }, 100);
  }

  onMouseLeave(): void {
    Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.pointer) {
          chart.pointer.reset(null, null);
        }
      }
    });
    if (this.chart) {
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      const tooltip = (this.chart as any).tooltip;

      if (tooltip) {
        tooltip.hide();
      }
    }
  }

  getChartOptions(): Highcharts.Options {
    const unit: string = this.units;
    const that = this;
    const config: Highcharts.Options = {
      tooltip: {
        formatter: function () {
          const tooltipContent = [];
          const date = new Date(this.x);
          if (this.x === Date.parse(date.toString())) {
            const tooltipDate = moment(this.x).format('MMM D, YYYY H:mm:ss');
            tooltipContent.push(tooltipDate);
          }
          tooltipContent.push('</span><br/>');
          tooltipContent.push('<span style="font-size: 12px;">');
          tooltipContent.push(this?.point?.name + ': ' + this?.point?.y + ' ' + unit);
          tooltipContent.push('</span><br/>');
          return tooltipContent.join('');
        }
      },
      series: this.dataSource,
      lang: {
        noData: 'No data found for selected time frame'
      }
    };
    return merge({}, config, this.chartOptions);
  }
}
